<template>
  <ul>
    <li
      v-for="(project, index) in localProjects"
      :key="`project-${index}`"
      class="flex items-center rp25 text-sm odd:base-background-color hover:text-orange cursor-pointer"
      @click.prevent="selectProject(!project.isSelected, project, index)"
    >
      <inputCheckbox
        :value="project.isSelected"
        class="rmr50"
      />

      <span>{{ project.project_name }} | ID: {{ project.project_id }}</span>
    </li>
  </ul>
</template>

<script>
import inputCheckbox from '../../form-components/input-checkbox.vue';
export default {
  props: {
    localProjects: Array
  },
  methods: {
    selectProject(value, project, index) {
      this.$emit('selectProject', value, project, index)
    }
  },
  components: {
    inputCheckbox,
  },
};
</script>

<style lang="scss" scoped>
.hover\:text-orange:hover {
  --text-opacity: 1;
  color: #ec9148;
  color: rgba(236, 145, 72, var(--text-opacity));
}
.odd\:base-background-color:nth-child(odd) {
  --bg-opacity: 1;
  background-color: #f8f8f8;
  background-color: rgba(rgb(248, 248, 248), var(--bg-opacity));
}
</style>
